import { useCharacterLimitQuery } from './operation.generated';

/**
 * Return the editor's character limit from GraphQL, but default to the value set in the
 * production/staging config files if for some reason the query fails.
 *
 * We ignore `user.[TEAM].productAccessLimits.editorCharacterLimit` since internally is calls
 * the same function as the property under `user`. Additionally the property under `user`
 * handles cases with trial and admin subscriptions.
 */
// eslint-disable-next-line import/prefer-default-export
export function useEditorCharacterLimit(): number {
  const { data } = useCharacterLimitQuery();
  return data?.user.productAccessLimits.editorCharacterLimit || 0;
}
